const disableScrollLock = () => {
  document.body.style.overflow = ''
}

const enableScrollLock = () => {
  document.body.style.overflow = 'hidden'
}

const scrollToTop = () => {
  if (window.scrollY > 0) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

export { disableScrollLock, enableScrollLock, scrollToTop }
